import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../layouts/full/shared/loadable/Loadable";
import { RouterName } from "./RouterName";
import CreateOrder from "src/pages/orders/CreateOrder";
import QuickQuotePage from "src/pages/Quick/QuickQuotePage";

const FullLayout = Loadable(lazy(() => import("../layouts/full/FullLayout")));
const BlankLayout = Loadable(
  lazy(() => import("../layouts/blank/BlankLayout")),
);

const SettingsPage = Loadable(
  lazy(() => import("../pages/settings/SettingsPage")),
);
const OrdersPage = Loadable(lazy(() => import("../pages/orders/OrdersPage")));
const OrderFullDetailPage = Loadable(
  lazy(() => import("../pages/orders/FullDetailPage")),
);
const ManifestsPage = Loadable(
  lazy(() => import("../pages/manifests/ManifestsPage")),
);
const OsndDashboard = Loadable(
  lazy(() => import("../pages/osnd/OsndDashboard")),
);

const LegsPage = Loadable(lazy(() => import("../pages/legs/LegsPage")));

const ControlPage = Loadable(
  lazy(() => import("../pages/control/ControlPage")),
);
const CustomersPage = Loadable(
  lazy(() => import("../pages/customers/CustomersPage")),
);
const TariffsPage = Loadable(
  lazy(() => import("../pages/tariffs/TariffsPage")),
);
const TariffDetailPage = lazy(
  () => import("src/pages/tariffs/TariffDetailPage"),
);
const ZonesPage = lazy(() => import("src/pages/zones/ZonesPage"));
const CarriersPage = Loadable(
  lazy(() => import("../pages/carriers/CarriersPage")),
);
const InvoicesPage = Loadable(
  lazy(() => import("../pages/analytics/InvoicesPage")),
);
const ConsolidatedInvoicePage = Loadable(
  lazy(() => import("../pages/analytics/ConsolidatedInvoicePage")),
);
const TeamsPage = Loadable(lazy(() => import("../pages/teams/TeamsPage")));

const EquipmentsPage = Loadable(
  lazy(() => import("../pages/equipments/EquipmentsPage")),
);

const AccessorialsPage = Loadable(
  lazy(() => import("../pages/accessorials/AccessorialsPage")),
);

const CategoriesPage = Loadable(
  lazy(() => import("../pages/categories/CategoriesPage")),
);

const Login = Loadable(
  lazy(() => import("../views/authentication/auth/Login")),
);

const Error = Loadable(lazy(() => import("../views/authentication/Error")));
const Maintenance = Loadable(
  lazy(() => import("../views/authentication/Maintenance")),
);

const ForgotPassword = Loadable(
  lazy(() => import("../views/authentication/auth/ForgotPassword")),
);

const ResetPassword = Loadable(
  lazy(() => import("../views/authentication/auth/ResetPassword")),
);

const TablePage = Loadable(lazy(() => import("../pages/table/UsageTable")));
const CreateBlankManifestPage = Loadable(
  lazy(
    () =>
      import("../pages/manifests/manifest-components/create-blank-manifest"),
  ),
);

const DashboardPage = Loadable(
  lazy(() => import("../pages/dashboard/dashboard-page")),
);

const DocumentPage = Loadable(
  lazy(() => import("../pages/analytics/DocumentPage")),
);
const Router = [
  {
    path: "/",
    element: <FullLayout />,
    children: [
      {
        path: RouterName.orders.orders,
        exact: true,
        element: <OrdersPage key="orders" />,
      },
      {
        path: RouterName.orders.createOrder,
        exact: true,
        element: <CreateOrder />,
      },
      {
        path: RouterName.orders.ordersDetail,
        exact: true,
        element: <OrderFullDetailPage />,
      },
      {
        path: RouterName.OSND.dashboard,
        exact: true,
        element: <OsndDashboard />,
      },
      {
        path: RouterName.OSND.orders,
        exact: true,
        element: <OrdersPage isOSND={true} key="OSND-orders" />,
      },
      {
        path: RouterName.OSND.orderDetail,
        exact: true,
        element: <OrderFullDetailPage isOSND={true} />,
      },
      {
        path: RouterName.OSND.createOrder,
        exact: true,
        element: <CreateOrder isOSND={true} />,
      },
      {
        path: RouterName.OSND.manifests,
        exact: true,
        element: <ManifestsPage isOSND={true} key="OSND-manifests" />,
      },
      {
        path: RouterName.OSND.manifestDetail,
        exact: true,
        element: <CreateBlankManifestPage />,
      },
      {
        path: RouterName.equipments.equipments,
        exact: true,
        element: <EquipmentsPage />,
      },
      {
        path: RouterName.manifests.manifests,
        exact: true,
        element: <ManifestsPage key="manifests" />,
      },
      {
        path: `${RouterName.manifests.blankManifest}/:id?`,
        exact: true,
        element: <CreateBlankManifestPage />,
      },
      {
        path: RouterName.legs.legs,
        exact: true,
        element: <LegsPage />,
      },
      {
        path: RouterName.control.control,
        exact: true,
        element: <ControlPage />,
      },
      {
        path: RouterName.customers.customers,
        exact: true,
        element: <CustomersPage />,
      },
      {
        path: RouterName.tariffs.tariffs,
        exact: true,
        element: <TariffsPage />,
      },
      {
        path: RouterName.tariffs.tariffDetails,
        exact: true,
        element: <TariffDetailPage />,
      },
      {
        path: RouterName.zones.zones,
        exact: true,
        element: <ZonesPage />,
      },
      {
        path: RouterName.carriers.carriers,
        exact: true,
        element: <CarriersPage />,
      },
      {
        path: RouterName.teams.teams,
        exact: true,
        element: <TeamsPage />,
      },
      {
        path: RouterName.quickQuote.quickQuote,
        exact: true,
        element: <QuickQuotePage />,
      },
      {
        path: RouterName.dashboard.dashboard,
        exact: true,
        element: <DashboardPage />,
      },
      {
        path: RouterName.invoices.invoices,
        exact: true,
        element: <InvoicesPage />,
      },
      {
        path: RouterName.settings.settings,
        exact: true,
        element: <SettingsPage />,
      },
      {
        path: RouterName.accessorials.accessorials,
        exact: true,
        element: <AccessorialsPage />,
      },
      {
        path: RouterName.categories.categories,
        exact: true,
        element: <CategoriesPage />,
      },
      {
        path: RouterName.table.table,
        exact: true,
        element: <TablePage />,
      },
      { path: "/404", element: <Error /> },
      { path: "*", element: <Navigate to="/" /> },
    ],
  },
  {
    path: "/",
    element: <BlankLayout />,
    children: [
      { path: "/auth/404", element: <Error /> },
      { path: RouterName.auth.login, element: <Login /> },
      { path: RouterName.auth.forgotPassword, element: <ForgotPassword /> },
      { path: RouterName.auth.resetPassword, element: <ResetPassword /> },
      { path: "/reset-password", element: <ResetPassword /> },
      { path: RouterName.auth.maintenance, element: <Maintenance /> },
      {
        path: RouterName.invoices.consolidatedInvoice,
        exact: true,
        element: <ConsolidatedInvoicePage />,
      },
      {
        path: RouterName.invoices.document,
        exact: true,
        element: <DocumentPage />,
      },
      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default Router;
